import { Dropdown } from 'antd'
import type { MenuProps } from 'antd'
import {
  CalendarOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FormOutlined,
  MoreOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { createElement } from 'react'
import { dispatcher } from '../pub_controller'
import { ComponentController } from './component_controller'

type IconType =
  | 'edit'
  | 'duplicate'
  | 'delete'
  | 'cancel'
  | 'calendar'
  | 'register'
  | 'view'
  | 'user'

type HttpMethod = 'get' | 'delete'

const iconMap: Record<IconType, JSX.Element> = {
  calendar: createElement(CalendarOutlined),
  cancel: createElement(CloseCircleOutlined),
  delete: createElement(DeleteOutlined),
  duplicate: createElement(CopyOutlined),
  edit: createElement(EditOutlined),
  register: createElement(FormOutlined),
  view: createElement(EyeOutlined),
  user: createElement(UserOutlined),
}

type QuickActionsProps = {
  actions: {
    className: string
    frame: string
    iconType: IconType
    label: string
    method: HttpMethod
    pubChannel: string
    pubAs: string
    type: string
    url: string
  }[]

  dispatcher: Function
}

const createMenuLink = ({ className, label, method, url }) => {
  return createElement(
    'a',
    {
      className: className,
      href: url,
      'data-turbo-method': method,
    },
    label,
  )
}

const createTurboModalMenuLink = ({
  className,
  dispatcher,
  label,
  pubChannel,
  url,
}) => {
  return createElement(
    'a',
    {
      className: className,
      onClick: (event) => {
        dispatcher('turbo-modal-get', pubChannel || 'turbo-modal', url)
      },
    },
    label,
  )
}

const QuickActions = ({ actions, dispatcher }: QuickActionsProps) => {
  const items: MenuProps['items'] = actions.map(
    ({ type, iconType, label, url, method, className, pubChannel, pubAs }) => {
      // hack point for other types of quick action links in the future
      // should that become relevant
      const labelElement =
        type === 'turbo-modal'
          ? createTurboModalMenuLink({
              className,
              dispatcher,
              label,
              pubChannel,
              url,
            })
          : createMenuLink({ className, label, method, url })
      return {
        icon: iconMap[iconType],
        key: url,
        label: labelElement,
      }
    },
  )
  const icon = createElement(MoreOutlined)
  return createElement(
    Dropdown,
    { menu: { items }, trigger: ['click'], arrow: true },
    icon,
  )
}

export class QuickActionsController extends ComponentController {
  get component() {
    return QuickActions
  }

  get initialProps() {
    const props = this.propsFromData

    return {
      ...props,
      dispatcher: (pubAs, pubChannel, pubDetail) => {
        dispatcher(this, pubAs, pubChannel, pubDetail)
      },
    }
  }
}
